// src/composables/reports/useTopClientesQuery.ts
import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';
import { getTopClientesAction } from '../actions';

export function useTopClientesQuery(limit: Ref<number> | number = 10) {
  const limitValue = typeof limit === 'number' ? limit : limit.value;

  const  query= useQuery({
    queryKey: ['top-clientes', limitValue],
    queryFn: async () => {
      const response = await getTopClientesAction(limitValue);
      return response.data;
    },
    refetchInterval: 60000,
    staleTime: 45000,
    placeholderData: (previousData) => previousData
  });
  const topClientesData = computed(() => query.data.value);
return {
    topClientesData,
   ...query,
  };
}